<template>
  <div class="guide" v-if="boxSpecifications">
    <box-select />
    <box-dimensions :active="activeBoxSpecification !== null" />
    <box-options :active="activeBoxSpecification !== null" />

    <div class="guide__summary">
      <server-errors />
      <offer-loader v-if="fetchPricesIsLoading"></offer-loader>
      <custom-offers v-if="responseCustomOffers || responseOptions.offerSuggestion" />
      <stock-offers v-if="responseStockOffers" />
    </div>

    <modal
      :open="modalOpen"
      :title="modalTitle"
      :content="modalContent"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BoxSelect from './components/BoxSelect';
import BoxDimensions from './components/BoxDimensions';
import BoxOptions from './components/BoxOptions';
import debounce from '../helpers/debounce';
import ServerErrors from './components/ServerErrors';
import CustomOffers from './components/CustomOffers';
import StockOffers from './components/StockOffers';
import Modal from './components/Modal';
import OfferLoader from './components/OfferLoader';

export default {
  components: {
    Modal,
    StockOffers,
    CustomOffers,
    ServerErrors,
    BoxOptions,
    BoxDimensions,
    BoxSelect,
    OfferLoader,
  },

  props: {
    dataset: Object,
  },

  created() {
    this.validateIncomingData();

    this.$store.commit('setDebug', this.dataset.debug);
    this.$store.commit('setModals', this.dataset.modals);
    this.$store.commit('setBoxSpecifications', this.dataset.boxSpecifications);
    this.$store.commit('setI18n', this.dataset.i18n);

    this.debouncedFetchPrices = debounce(this.fetchPrices.bind(this), 500);

    if (this.dataset.formInput && this.dataset.formInput !== '[]') {
      const formInput = JSON.parse(this.dataset.formInput);

      if (formInput.fefco) {
        this.$store.dispatch('setActiveBoxSpecification', formInput.fefco);
      }

      Object.keys(formInput).forEach((formInputKey) => {
        this.$store.commit('setFormInput', [formInputKey, formInput[formInputKey]]);
      });
    }
  },

  computed: {
    ...mapGetters([
      'boxSpecifications',
      'activeBoxSpecification',
      'formInput',
      'flatServerErrors',
      'responseCustomOffers',
      'responseStockOffers',
      'modalOpen',
      'modalTitle',
      'modalContent',
      'responseOptions',
      'fetchPricesIsLoading',
    ]),
  },

  watch: {
    '$store.getters.formInput'(formInput) {
      if (
        formInput.amount
        && formInput.type
      ) {
        this.debouncedFetchPrices();
      }
    },
  },

  methods: {
    fetchPrices() {
      this.$store.dispatch('fetchPrices', this.formInput);
    },

    /**
     * Validate that the data passed to the component is 'correct'.
     */
    validateIncomingData() {
      if (typeof this.dataset.modals === 'undefined') {
        throw new Error('Box guide requires modals.');
      }

      if (typeof this.dataset.boxSpecifications === 'undefined') {
        throw new Error('Box guide requires specifications and it should be an array.');
      }

      Object.values(this.dataset.boxSpecifications).forEach((specification) => {
        if (typeof specification.dimensions === 'undefined') {
          throw new Error('Specifications dimensions is missing');
        }

        if (typeof specification.type === 'undefined' || !Array.isArray(specification.type)) {
          throw new Error('Specifications types is missing or not an array');
        }

        if (typeof specification.amount === 'undefined') {
          throw new Error('Specifications amount is missing');
        }
      });
    },
  },
};
</script>

<style scoped>
.guide {
  font-size: .9375rem;
}

@media (max-width: 399px) {
  .guide {
    margin-left: -15px;
    margin-right: -15px;
  }
}

@media (min-width: 768px) {
  .guide__summary {
    margin-left: 7.5rem;
  }
}
</style>
